module.exports = __webpack_public_path__ + "img/HTIT-WST.51387e24.jpg";